import { post } from './api';

export const login = function(params) {
    return post('/login', params);
};

export const register = function(params) {
    return post('/register', params);
};

export const loginOut = function() {
    return post('/user/loginOut');
};
